import React, { useCallback, useEffect, useState, createContext, useContext } from 'react';
import { UpsellModal } from './UpsellModal';
interface UpsellContextValue {
  openUpsell: () => void;
}
const UpsellContext = createContext<UpsellContextValue>({
  openUpsell: () => {}
});
export const useUpsell = () => useContext(UpsellContext);
export const UpsellProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openUpsell = useCallback(() => setIsOpen(true), []);
  const closeUpsell = useCallback(() => setIsOpen(false), []);
  // Lock body scroll while modal is open
  useEffect(() => {
    if (isOpen) {
      const original = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = original;
      };
    }
  }, [isOpen]);
  return <UpsellContext.Provider value={{
    openUpsell
  }} data-id="element-218">
      {children}
      <UpsellModal isOpen={isOpen} onClose={closeUpsell} data-id="element-219" />
    </UpsellContext.Provider>;
};